import { StudentClassIdentifier } from '@/application/commons/enums/student-class.enum';

export const paywallData = {
  [StudentClassIdentifier.CurrentStudentClassHasExpired]: {
    illustration: 'electric-shock',
    title: 'Ops! Esse curso já foi encerrado',
    subtitle: 'O curso foi encerrado no dia endDate.',
  },
  [StudentClassIdentifier.CurrentStudentClassHasNotStarted]: {
    illustration: 'desktop',
    title: 'Seu curso ainda não iniciou.',
    subtitle: 'Mas não se preocupe, seu curso iniciará no dia startDate.',
  },
  [StudentClassIdentifier.CurrentStudentClassNotFound]: {
    illustration: 'running-girl',
    title: 'Ops! Você não tem acesso a essa turma',
    subtitle: 'Escolha outra turma.',
  },
};
